var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.section},[_c('div',{class:_vm.$style.button},[_c('v-button',{attrs:{"color":"primary","size":"lg"},on:{"click":_vm.onTryTrial}},[_vm._v(_vm._s(_vm.$t('profile.trial'))+" "+_vm._s(_vm.appCurrencySymbol(_vm.currentApp))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }